
import { useState, startTransition } from 'react';
import { useTwilioContext } from '@/context/TwilioContext';
import { useTwilioConfiguration } from '@/hooks/useTwilioConfiguration';
import { cn } from '@/lib/utils';
import { TwilioDialerHeader } from './TwilioDialerHeader';
import { TwilioDialerContent } from './TwilioDialerContent';

interface TwilioDialerProps {
  onClose: () => void;
  fullscreen?: boolean;
  showHeader?: boolean;
}

export const TwilioDialer = ({ onClose, fullscreen = false, showHeader = true }: TwilioDialerProps) => {
  const [isSpeakerOn, setIsSpeakerOn] = useState(true);
  
  // Use global Twilio context instead of local services
  const { 
    makeCall, 
    endCall, 
    callStatus, 
    callInProgress, 
    callSid, 
    toggleMute,
    isMuted,
    formattedDuration,
    micPermission,
    isInitializingDevices,
    requestPermissions,
    sendDTMF
  } = useTwilioContext();
  
  const { isTwilioConfigured } = useTwilioConfiguration();
  
  console.log('📱 TwilioDialer: Using global context state:', {
    callInProgress,
    callStatus,
    callSid,
    formattedDuration
  });
  
  const handleCall = async (phoneNumber: string) => {
    const success = await makeCall(phoneNumber);
    if (success) {
      console.log('✅ Call initiated successfully');
    }
  };
  
  const handleEndCall = async () => {
    console.log('🔴 End call button pressed');
    await endCall();
  };
  
  const handleMuteToggle = async () => {
    await toggleMute(!isMuted);
  };
  
  const handleSendDTMF = async (digit: string) => {
    await sendDTMF(digit);
  };
  
  return (
    <div className={cn(
      "overflow-hidden bg-background",
      fullscreen ? "h-full w-full flex flex-col" : "w-[320px]"
    )}>
      {showHeader && (
        <TwilioDialerHeader
          onClose={onClose}
          micPermission={micPermission}
          isInitializingDevices={isInitializingDevices}
          onRequestPermissions={requestPermissions}
        />
      )}
      
      <TwilioDialerContent className="flex-1" />
    </div>
  );
};
